import type { CurrentUser, ExtendedUser } from "../../utils/backend-types";

type CurrentUserFields = Pick<
  CurrentUser,
  | "admin_url"
  | "has_analyzer_license"
  | "has_api_settings_access"
  | "has_manager_license"
  | "is_staff"
  | "chat_enabled"
  | "userpilot_enabled"
>;

export interface TodoUser extends ExtendedUser, Partial<CurrentUserFields> {
  isSystemUser?: boolean;
}

export enum Mode {
  Normal = "normal",
  Onboarding = "onboarding",
  Universal = "universal"
}

export enum TodoUserDecision {
  Open = "open",
  Rejected = "rejected",
  Confirmed = "confirmed",
  Unclear = "unclear"
}

export enum TodoSystemDecision {
  Applicable = "applicable",
  NotApplicable = "not_applicable",
  CantTell = "cant_tell",
  NeedMoreInformation = "need_more_information"
}
